import BaseModal from 'app/views/modals/base_modal';
import tmpl from 'templates/confirm_api_key_disable_modal';
import { showSuccess, showErrorWithSupportLink, handleResponseError } from 'utils/messages';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  initialize() {
    this.$el.on('hidden.bs.modal', this.cancelDisable.bind(this));
  },
  events: {
    'click .cancel': 'cancelDisable',
    'click .disable-api-key': 'disableApiKey',
  },
  disableApiKey() {
    this.model.disableApiKey({
      afterSave: () => {
        showSuccess('Your API key is now disabled.');
      },
      afterError: response => {
        handleResponseError(response, errMsg => {
          showErrorWithSupportLink(`There was an error processing your request. ${errMsg}.`);
        });
      },
      complete: () => this.close(),
    });
  },
  cancelDisable() {
    // cancel the change and reset the view
    this.model.trigger('sync');
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/confirm_api_key_disable_modal.js